// @ts-nocheck

import Web3 from 'web3';
import { useEffect } from 'react';

export function addCustomNetwork(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!window.ethereum) {
      console.error('MetaMask is not installed');
      return reject('MetaMask is not installed');
    }

    const customNetwork = {
      chainId: '0x3b9b', // Hardcoded chain ID
      chainName: 'POODL Network',
      nativeCurrency: {
        name: 'POODL',
        symbol: 'POODL',
        decimals: 18,
      },
      rpcUrls: ['https://rpc.poodl.org'],
      blockExplorerUrls: ['https://explorer.poodl.org'],
    };

    // Add the custom network to MetaMask
    window.ethereum
      .request({
        method: 'wallet_addEthereumChain',
        params: [customNetwork],
      })
      .then(() => {
        console.log('Custom network added successfully');
        resolve(); // Resolve the promise when the network is added successfully
      })
      .catch((error) => {
        console.error('Error adding custom network:', error);
        reject(error); // Reject the promise on error
      });
  });
}



// Function to check if the chain ID exists in MetaMask wallet
export async function checkChainIdExists(chainId) {
  if (!window.ethereum) {
    console.error('MetaMask is not installed');
    return 0;
  }

  try {
    // Try to switch to the given chain ID
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: chainId }], // Pass the chain ID to switch
    });

    console.log("Chain ID exists in wallet");
    return 1; // Chain ID exists in the wallet
  } catch (error) {
    if (error.code === 4902) {
      // Chain is not added to MetaMask
      console.log("Chain ID does not exist in wallet");
      return 0; // Chain ID does not exist in the wallet
    } else {
      console.error('Error while checking chain ID:', error);
      return 0;
    }
  }
}
